import React, { useState, useEffect } from "react";
import "../styles/Home.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import homeBanner from "../../assets/images/home_banner.png";
import { newsData } from "../../data/newsData";
import news1Img from "../../assets/images/news/news_1.png";
import news2Img from "../../assets/images/news/news_2.png";
import news3Img from "../../assets/images/news/news_3.png";
import news4Img from "../../assets/images/news/news_4.png";
import team1 from "../../assets/images/teams/team_1.png";
import team2 from "../../assets/images/teams/team_2.png";
import team3 from "../../assets/images/teams/team_3.png";
import team4 from "../../assets/images/teams/team_4.png";
import team5 from "../../assets/images/teams/team_5.png";
import team6 from "../../assets/images/teams/team_6.png";
import team7 from "../../assets/images/teams/team_7.png";
import tier1 from "../../assets/images/tiers/aether.png";
import tier2 from "../../assets/images/tiers/nova.png";
import tier3 from "../../assets/images/tiers/comet.png";
import tier4 from "../../assets/images/tiers/stardust.png";
import whoWeAreVideo from "../../assets/video/who_we_are_video.mp4";

function Home() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activePhases, setActivePhases] = useState([1]);
  const [selectedMember, setSelectedMember] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      const section = document.getElementById(sectionId);
      if (section) {
        const headerHeight = document.querySelector(".header").offsetHeight;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }, [location]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const togglePhase = (phaseId) => {
    setActivePhases((prev) => {
      if (prev.includes(phaseId)) {
        return prev.filter((id) => id !== phaseId);
      }
      return [...prev, phaseId];
    });
  };

  const openModal = (member) => {
    setSelectedMember(member);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedMember(null);
    document.body.style.overflow = "auto";
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = document.querySelector(".header").offsetHeight;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    setIsMobileMenuOpen(false);
  };

  const handleShopNow = () => {
    navigate("/shop");
    window.scrollTo(0, 0);
  };

  const handleBuyNow = () => {
    navigate("/shop");
    window.scrollTo(0, 0);
  };

  const handleTierClick = (tierName) => {
    navigate("/shop", {
      state: {
        selectedTab: tierName.toLowerCase(),
        scrollTo: "tiers"
      }
    });
  };

  const problems = [
    {
      id: 1,
      title: "Fans have no financial ownership in the success of their favorite idols.",
      icon: "💰"
    },
    {
      id: 2,
      title: "Artists struggle with revenue transparency and limited fan-powered models.",
      icon: "📊"
    },
    {
      id: 3,
      title: "Traditional fan systems don't reward supporters for their loyalty or engagement.",
      icon: "🎯"
    }
  ];

  const solutions = [
    {
      id: 1,
      title: "Royalties for Fans",
      description: "Earn from AI Idol music streaming and real artist content.",
      icon: "💎"
    },
    {
      id: 2,
      title: "Dividends from Ecosystem Growth",
      description: "Starting from Tier 3, holders earn monthly dividends",
      icon: "📈"
    },
    {
      id: 3,
      title: "Exclusive Access",
      description: "Get involved in AI idol development, attend live shows, and access behind-the scenes content from Busters.",
      icon: "🎭"
    },
    {
      id: 4,
      title: "Backed by Marblings Co LTD",
      description: "Combining Web3 with real entertainment industry experience.",
      icon: "🏢"
    }
  ];

  const nftTiers = [
    {
      id: 1,
      name: "Aether",
      supply: "20",
      price: "8,888",
      benefits: ["Each supporter can receive, 1 Nova, 2 Comet, and 3 Stardust + Exclusive Aetherium Avatar"],
      icon: "🌟"
    },
    {
      id: 2,
      name: "Nova",
      supply: "3,000",
      price: "1,888",
      benefits: ["Music & Streaming Royalty 1.5%, Voting & Event Pass, Behind-the-scenes access, Plan goods first and reservation for limited collaborations NFTs, Goods 35% discount, Fast NFT Notification Priority"],
      icon: "✨"
    },
    {
      id: 3,
      name: "Comet",
      supply: "4,000",
      price: "588",
      benefits: ["Music Royalty 2%, Voting, Q%A, Avatar Utility, Community Rewards, Goods 20% Discount"],
      icon: "💫"
    },
    {
      id: 4,
      name: "Stardust",
      supply: "5,000",
      price: "188",
      benefits: ["Music Royalty 1%, Voting, Digital 3.0% Badge, Airdrops, Goods 10% Discount, Fast News Notification Priority"],
      icon: "⭐"
    }
  ];

  const shopItems = [
    {
      id: 1,
      name: "Hwan",
      category: "Boy AI Idols",
      price: "1,888",
      image: process.env.PUBLIC_URL + "/hwan.jpg"
    },
    {
      id: 2,
      name: "Jaemin",
      category: "Boy AI Idols",
      price: "588",
      image: process.env.PUBLIC_URL + "/jaemin.jpg"
    },
    {
      id: 3,
      name: "Kaito",
      category: "Boy AI Idols",
      price: "188",
      image: process.env.PUBLIC_URL + "/kaito.jpg"
    },
    {
      id: 4,
      name: "Seungmin",
      category: "Boy AI Idols",
      price: "1,888",
      image: process.env.PUBLIC_URL + "/seungmin.jpg"
    }
  ];

  const revenueItems = [
    {
      id: 1,
      title: "Royalties",
      description: "50% from AI Idol & Busters music distributed to NFT holders : 30% to creative team (Marblings, producers, devs): 20% reinvested into project growth.",
      icon: "💰"
    },
    {
      id: 2,
      title: "Dividens (for tier 3+)",
      description: "20% of total ecosystem revenue shared monthly: Other Sources.",
      icon: "📈"
    },
    {
      id: 3,
      title: "Merch Sales",
      description: "Concert ticketing: Licensing & brand collabs: AI content tools.",
      icon: "🛍️"
    }
  ];

  const roadmapItems = [
    {
      id: 1,
      phase: "Phase 1",
      title: "Foundation",
      items: ["NFT art & smart contract development", "AI Idol vocal model training", "Onboarding Busters as real-world collaborators"],
      status: "completed"
    },
    {
      id: 2,
      phase: "Phase 2",
      title: "Pre-Launch",
      items: ["Pre-sale & whitelist launch", "AI music teaser and beta experiences", "Community-building & KOL marketing"],
      status: "in-progress"
    },
    {
      id: 3,
      phase: "Phase 3",
      title: "Launch",
      items: ["NFT minting", "Monthly royalty & dividend release", "First AI Idol single released"],
      status: "upcoming"
    },
    {
      id: 4,
      phase: "Phase 4",
      title: "Fan Experience",
      items: ["Real-world fan meetups with Busters", "Joint AI + Busters live performance in AR/VR", "Fan voting for future idol direction"],
      status: "upcoming"
    },
    {
      id: 5,
      phase: "Phase 5",
      title: "Global Expansion",
      items: ["Expansion to metaverse venues", "AI + real idol collaboration albums", "Global brand & music partnerships"],
      status: "upcoming"
    }
  ];

  const uniqueFeatures = [
    {
      id: 1,
      title: "The First AI x Idol Fan Economy",
      icon: "🎭"
    },
    {
      id: 2,
      title: "Royalties Shared from Real and Virtual Music",
      icon: "💰"
    },
    {
      id: 3,
      title: "Global Access, On-Chain Transparency",
      icon: "🌐"
    },
    {
      id: 4,
      title: "Fans Co-Create the Future of Aetherium",
      icon: "✨"
    },
    {
      id: 5,
      title: "Backed by Marblings Co LTD — Proven in K-Pop Industry",
      icon: "🏢"
    }
  ];

  const teamMembers = [
    {
      id: 1,
      name: "Derek Kim",
      position: "CTO",
      description: ["Boston conservatory at Berkeley Music Integrated", "Disney / MARVEL Music Producer", "AKB48 Composer"],
      image: team1
    },
    {
      id: 2,
      name: "Paul Shin",
      position: "CEO",
      description: ["Pruple Management Entertainment", "Actor Management YDG Promotion", "Concert planning progress", "Movie & Drama Casting director"],
      image: team2
    },
    {
      id: 3,
      name: "Joshua Michael Hall",
      position: "AI Producer",
      description: ["University of Denver Computer Science", "Ai Design, Movie producer", "Hollywood movie trailer AI producer", "DDP trailer AI producer"],
      image: team3
    },
    {
      id: 4,
      name: "Sungwok Chung",
      position: "Data Scientist",
      description: ["PhD in Neuroscience", "Data Scientist & AI Researcher", "Machine Learning & Data Engineering", "Big Data & Cloud", "Blockchain Analytics", "Software Development"],
      image: team4
    },
    {
      id: 5,
      name: "Brault Axel Charles",
      position: "AI Designer",
      description: ["AI Character Design", "Custom roller producer", "Tile Resampling Technician", "AI Costume Design"],
      image: team5
    },
    {
      id: 6,
      name: "Vickie",
      position: "AI/Blockchain Advisor & Marketing",
      description: ["Spokesman at Marbling", "Marketing Director", "Japanese marketing consultant"],
      image: team6
    },
    {
      id: 7,
      name: "Hans Jung",
      position: "Business Director",
      description: ["Managing Director at Nikan Korea Inc", "Business Consultant at Marbling", "Business Development & PR", "DDP trailer AI producer"],
      image: team7
    }
  ];

  return (
    <div id="Home">
      <Header />
      <main>
        <section className="hero">
          <div className="hero-content">
            <div className="hero-text">
              <h3 className="brand">Aetherium</h3>
              <h1 className="title">WHERE AI IDOLS MEET REAL-WORLD STARDOM</h1>
              <p className="description">The first NFT ecosystem bridging AI idols and real K-Pop artists under Marblings Co LTD, bringing fans and artists together in a revolutionary new economy.</p>
              <button onClick={handleShopNow} className="cta-button">
                Buy Now Presale
              </button>
              <div className="tier-images">
                <div className="tier-image-container" onClick={() => handleTierClick("Aether")}>
                  <img src={tier1} alt="Aether" className="tier-image" />
                  <span className="tier-label">Aether</span>
                </div>
                <div className="tier-image-container" onClick={() => handleTierClick("Nova")}>
                  <img src={tier2} alt="Nova" className="tier-image" />
                  <span className="tier-label">Nova</span>
                </div>
                <div className="tier-image-container" onClick={() => handleTierClick("Comet")}>
                  <img src={tier3} alt="Comet" className="tier-image" />
                  <span className="tier-label">Comet</span>
                </div>
                <div className="tier-image-container" onClick={() => handleTierClick("Stardust")}>
                  <img src={tier4} alt="Stardust" className="tier-image" />
                  <span className="tier-label">Stardust</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="who" className="who-we-are">
          <div className="section-content">
            <h2 className="section-title">Who We Are?</h2>

            <div className="video-container">
              <video controls autoPlay muted loop playsInline className="who-we-are-video">
                <source src={whoWeAreVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <h3 className="section-subtitle">Aetherium is an innovative platform under Marblings Co LTD that powers:</h3>

            <div className="features">
              <div className="feature-card">
                <div className="feature-icon">🤖</div>
                <h3>AI Idol "Aetherium"</h3>
                <p>Fully virtual music artist powered by generative AI.</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🎤</div>
                <h3>Real-world K-Pop Idol Group "Busters"</h3>
                <p>Official partner and brand ambassador.</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">💫</div>
                <h3>Fan-first ecosystem</h3>
                <p>Built to reward, include, and grow with its most passionate fans.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="news" className="news">
          <div className="section-content">
            <h2 className="section-title">News</h2>
            <div className="mini-news-grid" style={{ marginBottom: "2rem" }}>
              {newsData
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .slice(0, 4)
                .map((news) => (
                  <Link to={`/news/${news.id}`} className="mini-news-card news-card" key={news.id}>
                    <div className="news-image">
                      <img src={news.img} alt={news.title} />
                    </div>
                    <div className="news-content">
                      <div className="news-meta">
                        <span>{news.date}</span>
                      </div>
                      <h3 className="news-title">{news.title}</h3>
                      <div className="read-more">Read More</div>
                    </div>
                  </Link>
                ))}
            </div>
            <div className="news-action-area" style={{ textAlign: "center", marginTop: "3rem" }}>
              <p style={{ fontSize: "1.15rem", color: "#222", fontWeight: 600, marginBottom: "1.5rem", letterSpacing: "-0.5px" }}>You can find the latest news and announcements on our full news page.</p>
              <button
                className="go-newslist-btn highlight-btn"
                style={{ background: "var(--primary-color)", color: "#fff", border: "none", borderRadius: "8px", padding: "1rem 2.5rem", fontWeight: 700, fontSize: "1.15rem", cursor: "pointer", boxShadow: "0 4px 16px rgba(123,63,228,0.12)", transition: "all 0.2s" }}
                onClick={() => navigate("/news")}
              >
                See all news
              </button>
            </div>
          </div>
        </section>

        <section id="problem" className="problems">
          <div className="section-content">
            <h2 className="section-title">The Problem We Solve</h2>
            <div className="problem-cards">
              {problems.map((problem) => (
                <div key={problem.id} className="problem-card">
                  <div className="problem-icon">{problem.icon}</div>
                  <h4 className="problem-title">{problem.title}</h4>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="solution" className="solutions">
          <div className="section-content">
            <h2 className="section-title">Our Solution</h2>
            <div className="solution-cards">
              {solutions.map((solution) => (
                <div key={solution.id} className="solution-card">
                  <div className="solution-icon">{solution.icon}</div>
                  <h3 className="solution-title">{solution.title}</h3>
                  <p className="solution-description">{solution.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="nft-tiers" className="nft-tiers">
          <div className="section-content">
            <h2 className="section-title">NFT Tiers & Benefits</h2>
            <div className="tier-cards">
              {nftTiers.map((tier) => (
                <div key={tier.id} className="tier-card">
                  <div className="tier-header">
                    <span className="tier-number">Tier {tier.id}</span>
                    <h3 className="tier-name">{tier.name}</h3>
                  </div>
                  <div className="tier-info">
                    <div className="info-item">
                      <span className="label">Supply</span>
                      <span className="value">{tier.supply}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Price</span>
                      <span className="value">{tier.price} USDT</span>
                    </div>
                  </div>
                  <div className="tier-benefits">
                    <h4>Key Benefits</h4>
                    <div className="benefits-list">
                      {tier.benefits.map((benefit, index) => (
                        <p key={index} className="benefit-item">
                          {benefit}
                        </p>
                      ))}
                    </div>
                  </div>
                  <button onClick={handleBuyNow} className="buy-button">
                    Buy Now
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <section id="shop" className="shop">
          <div className="section-content">
            <h2 className="section-title">Shop</h2>
            <div className="shop-grid">
              {shopItems.map(item => (
                <div key={item.id} className="shop-card">
                  <div className="shop-image">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <div className="shop-content">
                    <div className="shop-category">{item.category}</div>
                    <h3 className="shop-name">{item.name}</h3>
                    <div className="shop-rating">
                      <span className="star">☆</span>
                      <span className="star">☆</span>
                      <span className="star">☆</span>
                      <span className="star">☆</span>
                      <span className="star">☆</span>
                    </div>
                    <div className="shop-price">${item.price}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        <section id="revenue" className="revenue">
          <div className="section-content">
            <h2 className="section-title">Revenue and Distribution Model</h2>
            <div className="revenue-grid">
              {revenueItems.map((item) => (
                <div key={item.id} className="revenue-card">
                  <div className="hover-effect"></div>
                  <div className="revenue-icon">{item.icon}</div>
                  <h3 className="revenue-title">{item.title}</h3>
                  <p className="revenue-description">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="roadmap" className="roadmap">
          <div className="section-content">
            <h2 className="section-title">Roadmap</h2>
            <div className="roadmap-timeline">
              {roadmapItems.map((item) => (
                <div key={item.id} className={`roadmap-item ${item.status} ${activePhases.includes(item.id) ? "active" : ""}`}>
                  <div className="timeline-point"></div>
                  <div className="roadmap-content">
                    <div className="phase-header" onClick={() => togglePhase(item.id)}>
                      <div className="phase-tag">{item.phase}</div>
                      <span className="toggle-icon">{activePhases.includes(item.id) ? "−" : "+"}</span>
                    </div>
                    <ul className={`roadmap-list ${activePhases.includes(item.id) ? "active" : ""}`}>
                      {item.items.map((listItem, index) => (
                        <li key={index} style={{ "--item-index": index }}>
                          {listItem}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="why" className="unique-features">
          <div className="section-content">
            <h2 className="section-title">Why is Aetherium Unique?</h2>
            <div className="features-grid">
              {uniqueFeatures.map((feature) => (
                <div key={feature.id} className="feature-card">
                  <div className="feature-icon">{feature.icon}</div>
                  <h3 className="feature-title">{feature.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="team" className="team">
          <div className="section-content">
            <h2 className="section-title">Our Team</h2>
            <div className="team-grid">
              {teamMembers.map((member) => (
                <div key={member.id} className="team-card" onClick={() => openModal(member)}>
                  <div className="member-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="member-info">
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-position">{member.position}</p>
                  </div>
                </div>
              ))}
            </div>
            {selectedMember && (
              <div className="team-modal active" onClick={closeModal}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-close" onClick={closeModal}></div>
                  <div className="modal-body">
                    <div className="modal-image">
                      <img src={selectedMember.image} alt={selectedMember.name} />
                    </div>
                    <div className="modal-info">
                      <h3 className="member-name">{selectedMember.name}</h3>
                      <p className="member-position">{selectedMember.position}</p>
                      <div className="member-description">
                        {selectedMember.description.map((line, index) => (
                          <p key={index}>{line}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default Home;
